export const GTMApiStatus = {
  Started: 'Started',
  Success: 'Success',
  Failed: 'Failed',
} as const;
export type GTMApiStatus = typeof GTMApiStatus[keyof typeof GTMApiStatus];

export const GTMEvents = {
  PageView: 'page_view',
  Click: 'click',
  AccordionExpand: 'accordion_expand',
  ChatOpen: 'chat_open',
  DeviceInventoryView: 'device_inventory_view',
  DeviceInventoryAddView: 'device_inventory_add_view',
  DeviceInventoryAddFail: 'device_inventory_add_fail',
  DeviceInventoryAddComplete: 'device_inventory_add_complete',
  Onboarding: 'onboarding',
  Error: 'error',
  Login: 'login',
  ResetPassword: 'reset_password',
  ServiceRequestView: 'service_request_view',
  ServiceClaimStepView: 'serviceClaim_step_view',
  ServiceClaimStepComplete: 'serviceClaim_step_complete',
  ServiceClaimFail: 'serviceClaim_fail',
  ModalView: 'modal_view',
  AccountUpdate: 'account_update',
  TooltipInteraction: 'tooltip_interaction',
  SavePayment: 'save_payment',
} as const;
export type GTMEvents = typeof GTMEvents[keyof typeof GTMEvents];

export const GTMPaymentMethod = {
  ACH: 'ACH',
  Credit: 'Credit',
  Debit: 'Debit',
} as const;
export type GTMPaymentMethod = (typeof GTMPaymentMethod)[keyof typeof GTMPaymentMethod];

export const GTMTooltipInteractionType = {
  Hover: 'hover',
  Tap: 'tap',
} as const;
export type GTMTooltipInteractionType = (typeof GTMTooltipInteractionType)[keyof typeof GTMTooltipInteractionType];

export const GTMDeviceFlow = {
  AddDevice: 'Add device',
  EditDevice: 'Edit device',
  DeleteDevice: 'Delete device',
} as const;
export type GTMDeviceFlow = typeof GTMDeviceFlow[keyof typeof GTMDeviceFlow];

export const GTMClaimType = {
  FileAClaim: 'File a claim',
  CancelMyPlan: 'Cancel my plan',
  TechSupport: 'Tech support links',
} as const;
export type GTMClaimType = (typeof GTMClaimType)[keyof typeof GTMClaimType];

export const GTMOnboardingEvents = {
  Lookup: 'onboarding_account_lookup',
  Start: 'onboarding_form_start',
  InProcess: 'onboarding_form_step_view',
  Complete: 'onboarding_form_step_complete',
  Failed: 'onboarding_form_fail',
  FormComplete: 'onboarding_form_complete',
} as const;
export type GTMOnboardingEvents = typeof GTMOnboardingEvents[keyof typeof GTMOnboardingEvents];

export const GTMLoginEvents = {
  Login: 'login',
  LoginSuccess: 'login_success',
  LoginError: 'login_error',
  LoginMFA: 'login_MFA',
  LoginInProcess: 'login_step_view',
  LoginComplete: 'login_step_complete'
} as const;
export type GTMLoginEvents = typeof GTMLoginEvents[keyof typeof GTMLoginEvents];


export const LoginSteps = {
  AccountLookup: 'Account Lookup',
  SelectVerificationChannel: 'Select Verification Channel',
  GatherContactInfo: 'Gather Contact Info',
  GatherMissingInfo: 'Gather Missing Info',
  VerifyOTP: 'Verify OTP',
} as const;
export type LoginSteps = typeof LoginSteps[keyof typeof LoginSteps];

export const OnboardingSteps = {
  CreateLogin: 'Create Login',
  Start: 'Start Onboarding',
  VerifyAccount: 'Verify Account',
  CreateOTP: 'Create OTP',
  VerifyOTP: 'Verify OTP',
  ResendOTP: 'Resend OTP',
  ReviewContact: 'Review Contact',
  VerifyNewEmail: 'Verify New Email',
  CreateOTPForEditedEmail: 'Create OTP For Edited Email',
  EditPhone: 'Edit Phone',
  CreateOTPForEditedPhone: 'Create OTP For Edited Phone',
  ReviewAddress: 'Review Address',
  EditAddress: 'Edit Address',
  SaveAddress: 'Save Address',
  CreatePassword: 'Create Password',
  Success: 'Success',
  LookupAddress: 'Lookup Address',
  Lookup: 'Account Lookup',
} as const;
export type OnboardingSteps = typeof OnboardingSteps[keyof typeof OnboardingSteps];

export const GTMServiceRequestSteps = {
  Claim: 'Select claim type',
  Equipment: 'Add device',
  Gssp: 'Send to GSSP',
} as const;
export type GTMServiceRequestSteps = (typeof GTMServiceRequestSteps)[keyof typeof GTMServiceRequestSteps];


export const GTMPlanAddOnEvents = {
  PlanAddOnView: 'plan_addOn_view',
  PlanAddOnFail: 'plan_addOn_fail',
  PlanAddOnStepComplete: 'plan_addOn_step_complete',
  PlanAddOnPaymentView: 'plan_addOn_payment_view',
  PlanAddOnPaymentSuccess: 'plan_addOn_payment_success',
} as const;
export type GTMPlanAddOnEvents = (typeof GTMPlanAddOnEvents)[keyof typeof GTMPlanAddOnEvents];



export const GTMModalCategories = {
  ServiceDetail: 'Service Detail',
  Payment: 'Payment',
  Informative: 'Informative',
} as const;
export type GTMModalCategories = (typeof GTMModalCategories)[keyof typeof GTMModalCategories];

export const GTMAccountUpdateSteps = {
  Password: 'Password',
  Billing: 'Billing',
  Profile: 'Profile',
} as const;
export type GTMAccountUpdateSteps = (typeof GTMAccountUpdateSteps)[keyof typeof GTMAccountUpdateSteps];

export const GTMPasswordResetEvents = {
  Start: 'reset_password_start',
  EmailSent: 'reset_password_email_sent',
  EmailError: 'reset_password_email_error',
  View: 'reset_password_view',
  Complete: 'reset_password_complete',
  Failed: 'reset_password_failed',
} as const;
export type GTMPasswordResetEvents = (typeof GTMPasswordResetEvents)[keyof typeof GTMPasswordResetEvents];




